//@ts-nocheck
import {SET_MYFILES, RESET_MYFILES_FILTERS} from '../storeConstant';
   
    
export const setMyFilesData = (value) => {
    return {
        type: SET_MYFILES,
        payload: value
    }
}

export const resetMyFilesFilters = (value) => {
    return {
        type: RESET_MYFILES_FILTERS,
        payload: value
    }
}
